import React, { useState } from 'react';
import Popup from "../imagepopup";


function Zome() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const handleImageClick = (image) => {
    setSelectedImage(image);
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setSelectedImage("");
  };



  return (
    
    <section className="sec-box project section-padding radius-15">
        <div className="next-prev">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="d-flex align-items-center">
              <div className="next ml-auto">
                <h6 className="sub-title back-to-work">
                  <a href="/works">
                  <i className="fas fa-long-arrow-alt-left"></i> Back to works
                  </a>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-lg-11">
          <div className="img mb-80">
            <img
              src="/assets/imgs/works/p37.jpg"
              alt=""
              className="radius-5"
            />
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-7">
              <div className="cont md-mb50">
              <h3 className="mb-15 fw-500">Project Description:</h3>
                <p>
                As a UI/UX Designer, I was responsible for designing and developing the Zome Energy Network application, a platform that enables users to track, monitor, and analyze energy consumption and network efficiency. The application provided real-time insights, energy usage trends, and optimization recommendations, helping users make informed decisions about their energy consumption.
                </p>
                <p className="mt-15">
                Focused on delivering a data-driven, intuitive, and visually engaging interface, ensuring seamless access to energy tracking, analytics, and reporting features. Utilized wireframing, prototyping, and front-end technologies to create a scalable and user-friendly experience.
                </p>
                <div className="mt-30">
                <h6 className="mb-15 line-height-28">
                  Roles & Responsibilities:
                  </h6>

                  <p>As a <strong>UI/UX Designer</strong>, I was responsible for:</p>
                  <ul className="rest list-arrow mt-50">
                    <li>
                      <h6 className="inline fz-15">
                      User Experience Research & Analysis: Conducted user research, workflow analysis, and usability testing to enhance the interface for energy professionals and consumers.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Wireframing & Prototyping: Designed interactive wireframes and high-fidelity prototypes using Adobe Photoshop, and Axure to define user journeys and interactions.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Energy Monitoring Dashboard UI: Developed real-time dashboards displaying energy consumption, grid status, and efficiency metrics.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Data Visualization & Analytics UI: Designed interactive charts, graphs, and reports to help users analyze and optimize their energy usage.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Responsive & Cross-Platform UI: Created mobile-friendly and web-responsive designs ensuring seamless access across desktop, tablets, and mobile devices.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Branding & UI Consistency: Maintained Zome Energy’s brand identity, ensuring a modern and professional look and feel across all UI components.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Performance & Accessibility Optimization: Designed the application with fast-loading UI components, adhering to WCAG accessibility standards for inclusive user access.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Collaboration with Energy Experts & Development Teams: Worked closely with energy analysts, product managers, and developers to align UI/UX design with business goals and technical feasibility.

                      </h6>
                    </li>
                  </ul>
                  
                  <p className="mt-25">
                  This project helped deliver a user-centric, data-rich energy management platform, enabling businesses and consumers to efficiently track and optimize their energy consumption, contributing to sustainability and cost-saving initiatives.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="info sub-bg" id="sticky_item">
                <ul>
                  <li className="mb-30">
                    <span className="sub-title">
                      <i className="far fa-calendar-alt mr-10"></i> Date :
                    </span>
                    <p> August 2008</p>
                  </li>
                  <li className="mb-30">
                    <span className="sub-title">
                      <i className="fas fa-list-ul mr-10"></i> Categories :
                    </span>
                    <p>UI/UX Designer</p>
                  </li>
                  <li>
                    <span className="sub-title">
                      <i className="far fa-user mr-10"></i> Client :
                    </span>
                    <p>Zome</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="imgs mt-80">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="row md-marg">
              <div className="col-md-6">
                <div className="img sm-mb30">
                  <img src="/assets/imgs/works/p36.jpg" alt=""  onClick={() => handleImageClick("/assets/imgs/works/p36.jpg")} />
                </div>
              </div>
              <div className="col-md-6">
                <div className="img">
                  <img src="/assets/imgs/works/p38.jpg" alt=""  onClick={() => handleImageClick("/assets/imgs/works/p38.jpg")} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      
      <div className="next-prev">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="d-flex align-items-center mt-80 pt-80 bord-thin-top">
              <div className="prev">
                <h6 className="sub-title">
                  <a href="/sony">
                    <i className="fas fa-long-arrow-alt-left"></i> Prev Project
                  </a>
                </h6>
              </div>
              <div className="next ml-auto">
                <h6 className="sub-title">
                
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      
                                    
                  {/* Popup for images */}
                  <Popup
        isOpen={isPopupOpen}
        closePopup={closePopup}
        popupImage={selectedImage}
      />
    </section>
  );
}

export default Zome;
